export var VideoScripts;
(function (VideoScripts) {
    VideoScripts["PRODUCT"] = "product";
    VideoScripts["GENERAL"] = "general";
    VideoScripts["GENERAL_TEMPLATE"] = "general_template";
})(VideoScripts || (VideoScripts = {}));
//# sourceMappingURL=VideoScripts.js.map